import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbNavModule, NgbAccordionModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

// Swiper Slider
import { SlickCarouselModule } from 'ngx-slick-carousel';

// Counter
import { CountUpModule } from 'ngx-countup';

import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { TitleCasePipe } from './pipes/title-case.pipe';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectFileComponent } from './select-evidencia/select-evidencia.component';


@NgModule({
  declarations: [
    BreadcrumbsComponent,
    TitleCasePipe,
    SelectFileComponent
  ],
  imports: [
    CommonModule,
    NgbNavModule,
    NgbAccordionModule,
    NgbDropdownModule,
    SlickCarouselModule,
    CountUpModule,
    ReactiveFormsModule
  ],
  exports: [BreadcrumbsComponent, TitleCasePipe, SelectFileComponent]
})
export class SharedModule { }
